<template>
  <div class="animated fadeIn">
    <b-row v-if="loading">
      <b-col md="6">
        <atom-spinner
          :animation-duration="1000"
          :size="60"
          color="#ff1d5e"
          class="float-right my-5"
        />
      </b-col>
    </b-row>
    <b-row v-if="!loading">
      <b-col>
        <ComponentNewHeader
          title="Item Details"
          :hasSearch="false"
          :hasCreate="false"
          :hasReload="false"
          :hasback="true"
          @back-press="backNavigate"
        />
      </b-col>
      <b-col sm="12">
        <b-card>
          <div>
            <b-card>
              <b-row class="ml-5">
                <b-col sm="4">
                  <b-form-group
                    label="Icon Image"
                    label-for="SmallImage"
                    :label-cols="7"
                    :horizontal="true"
                  ></b-form-group>
                  <div style="height: 200px; width: 180px">
                    <img
                      :src="itemObj.product_summary.images.icon"
                      style="height: 200px; width: 180px"
                    />
                  </div>
                </b-col>
                <b-col sm="4">
                  <b-form-group
                    label="Small Image"
                    label-for="SmallImage"
                    :label-cols="7"
                    :horizontal="true"
                  ></b-form-group>
                  <div style="height: 200px; width: 180px">
                    <img
                      :src="itemObj.product_summary.images.smallImage"
                      style="height: 200px; width: 180px"
                    />
                  </div>
                </b-col>
                <b-col sm="4">
                  <b-form-group
                    label="Big Image"
                    label-for="BigImage"
                    :label-cols="7"
                    :horizontal="true"
                  ></b-form-group>
                  <div style="height: 200px; width: 180px">
                    <img
                      :src="itemObj.product_summary.images.bigImage"
                      style="height: 200px; width: 180px"
                    />
                  </div>
                </b-col>
              </b-row>
            </b-card>
          </div>
          <div v-for="(entry, idx) in attributesMap.entries()" :key="idx">
            <b-row>
              <b-col
                v-for="(item, index) in entry[1]"
                :key="index"
                :md="['Array'].includes(item.type) ? 12 : 6"
                :style="{
                  display:
                    item.type !== 'Array' ||
                    (item.type === 'Array' &&
                      valuesMap[item.name] &&
                      valuesMap[item.name][0])
                      ? 'block'
                      : 'none',
                }"
              >
                <field
                  v-if="item.name !== 'b2bType'"
                  :fieldType="item.type"
                  :fieldName="item.name"
                  :displayName="
                    item.attributeLabel && item.attributeLabel[tenantLang]
                      ? item.attributeLabel[tenantLang]
                      : item.name
                  "
                  :onChange="fieldChange"
                  :value="valuesMap[item.name]"
                  :id="item._id"
                  :isRequired="item.isRequired"
                  :subFields="item.attributeItems"
                  :level="0"
                  :meta="[{ name: item.name, type: item.type }]"
                  :active="activeIndex"
                  :index="index"
                  :setActive="setActive"
                  :UIConcern="item.UIConcern"
                  :arrayChange="arrayChange"
                  :valuesMap="valuesMap"
                  :disabled="true"
                  :visibility="item.visibility ? item.visibility.onShow : true"
                />
                <card v-if="item.name === 'b2bType'">
                  <label class="card-title">{{ item.name }}</label>
                  <b-col class="pb-1">
                    <eb-select
                      type="text"
                      :id="'b2bType'"
                      v-model="typeB2b"
                      :options="selectB2b"
                      :selected="typeB2b"
                      label="text"
                      placeholder="Select b2b Type"
                    ></eb-select>
                  </b-col>
                </card>
              </b-col>
            </b-row>
          </div>
          <div v-if="isAddresscapture">
            <b-row>
              <b-col>
                <Card>
                  <div class="wrap">
                    <b-form-group>
                      <p class="head">Location</p>
                      <b-form-input
                        :value="itemObj.Address.Address"
                        :disabled="true"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                </Card>
              </b-col>
            </b-row>
          </div>
          <div>
            <a-divider />
            <div
              v-if="itemObj && itemObj.variations && itemObj.variations.length"
            >
              <h3>Variations</h3>
              <b-row v-for="(va, i) in itemObj.variations" :key="i">
                <b-col
                  md="2"
                  v-for="(f, j) in Object.keys(va.attributes)"
                  :key="j"
                >
                  {{ f }}: {{ va.attributes[f] }}
                </b-col>
                <b-col md="2"> Price: {{ va.Price }} </b-col>
                <b-col md="2"> Discount: {{ va.Discount }} </b-col>
                <b-col md="3">
                  Discount Percentage: {{ va.DiscountPercentage }}
                </b-col>
              </b-row>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<style scoped>
.flex-row {
  display: flex;
}
</style>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import cTable from "../base/Table.vue";
import Field from "@/components/Item/Field";
import Card from "../../components/Generics/Card.vue";
import SingleImage from "../../components/Common/Image.vue";
import ebSelect from "@/components/FormElements/Select.vue";
import VueUploadMultipleImage from "@/components/FormElements/VueUploadMultipleImage";
import locationMixins from "@/mixins/addressLocation";
import locationaddress from "@/components/LocationElement/addressAutocomplete";
import { BUCKET_BASEURL, GATEWAY_BASEURL } from "@/services/index";
import { mapGetters } from "vuex";
import Variance from "@/components/Variance/Variance.vue";
import ComponentNewHeader from "@/components/componentNewHeader";
import { AtomSpinner } from "epic-spinners";
export default {
  name: "viewItem",
  dark: {
    type: Boolean,
    default: false,
  },
  components: {
    cSwitch,
    cTable,
    Card,
    field: Field,
    SingleImage,
    locationaddress,
    ebSelect,
    VueUploadMultipleImage,
    Variance,
    ComponentNewHeader,
    AtomSpinner,
  },
  data() {
    return {
      typeB2b: {},
      itemObj: null,
      iconImagedata: null,
      smallImagedata: null,
      landingImagedata: null,
      alternateImages: [],
      inputObj: {
        Name: "",
        description_summary: "",
        provider: null,
        catalogId: "",
        images: {
          icon: "",
          smallImage: "",
          bigImage: "",
          alternateImages: [],
        },
      },
      externalAttribute: [],
      attributesMap: new Map(),
      valuesMap: {},
      activeIndex: null,
      submitted: false,
      location: {
        address: "",
        data: {},
        lat: "",
        lng: "",
      },
      isAddresscapture: false,
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      tenantLang: "tenant/GetTenantLanguage",
      partnerAllData: "partner/GetPartnerData",
    }),
    userRole() {
      if (this.$store.getters["auth/getUserRole"]) {
        return this.$store.getters["auth/getUserRole"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
      }
    },
    selectB2b() {
      return [
        {
          text: "Sell to Customer",
          value: 0,
        },
        {
          text: "Sell to Merchant",
          value: 1,
        },
        {
          text: "Sell to Both",
          value: 2,
        },
      ];
    },
  },
  props: {
    context: {
      type: String,
    },
  },
  mixins: [locationMixins],
  methods: {
    async fetchImages() {
      this.iconImagedata = await this.getImageUrl(
        this.itemObj.product_summary.images.icon
      );
      this.smallImagedata = await this.getImageUrl(
        this.itemObj.product_summary.images.smallImage
      );
      this.landingImagedata = await this.getImageUrl(
        this.itemObj.product_summary.images.bigImage
      );
    },
    backNavigate() {
      if (this.userRole === "Tenant") {
        this.$router.push({
          name: "partner-item",
          params: { id: this.partnerAllData._id },
        });
      } else {
        this.$router.push("/item");
      }
    },
    getImageKeyfromURL(imageURL) {
      const key = imageURL.replace(BUCKET_BASEURL, "");
      return key;
    },
    async getImageUrl(imageURL) {
      const imageKey = await this.getImageKeyfromURL(imageURL);
      return `${GATEWAY_BASEURL}/resize/index.php?width=300&height=250&quality=100&name=${imageKey}`;
    },
    fieldChange(data) {
      if (data.meta[0].name === "Name") {
        this.inputObj.Name = data.value;
        this.inputObj.description_summary = data.value;
      } else {
        if (data.meta[0].type === "String" && data.meta[0].name !== "Title") {
          this.inputObj[data.meta[0].name] = data.value;
        } else if (data.meta[0].type === "Number") {
          this.inputObj[data.meta[0].name] = data.value;
        }
      }
    },
    setActive(i) {
      this.activeIndex = this.activeIndex == i ? -1 : i;
    },
    arrayChange(data) {
      let { index, type, e, fieldName } = data;
      let { meta, value, action, arrObj } = data;
      let updateDoc = { ...this.valuesMap };
      let temp = this.valuesMap;
      let parent = temp;
      let path = "";
      for (let i = 0; i < meta.length; i++) {
        let item = meta[i],
          { type, name } = item;
        if (["Object", "String", "Number", "Array"].includes(type)) {
          parent = temp;
          path = item.name;
          temp = temp[item.name];
        }
      }
      let name = index;
      switch (type) {
        case "check": {
          this.$set(temp[index], "checked", e.target.checked);
          break;
        }
        case "select": {
          this.$set(parent, fieldName, e);
          break;
        }
        case "radio": {
          this.$set(parent, fieldName, e);
        }
      }
      if (arrObj === true) {
        switch (action) {
          case "change": {
            this.$set(
              parent,
              path,
              temp.map((item, idx) =>
                idx === index
                  ? {
                      ...item,
                      [fieldName]: e,
                    }
                  : item
              )
            );
            break;
          }
          case "add": {
            let tObj = {};
            let keys = Object.keys(temp[0]);
            for (let i = 0; i < keys.length; i++) {
              tObj[keys[i]] = "";
            }
            this.$set(parent, path, temp.concat([tObj]));
          }
          case "remove": {
            temp.splice(index, 1);
          }
        }
      }
    },
  },
  mounted: async function () {
    let userID = this.$store.getters["auth/getUserID"];
    this.inputObj.provider = userID;
    await this.$store.dispatch("item/fetchItemById", this.$route.params.id);
    let data = this.$store.getters["item/GetCurrentItemObject"];
    let result = data.response[0];
    this.itemObj = result;
    this.typeB2b = this.selectB2b.filter((sellTo) => {
      return sellTo.value == this.itemObj?.b2bType;
    });
    this.fetchImages();
    let keys = Object.keys(result);
    let typeSet = new Set(["String", "Number", "Object", "Array"]);
    let attributesMap = new Map([
      ["String", []],
      ["Number", []],
      ["Object", []],
      ["Array", []],
    ]);
    let valuesMap = result;
    result.attributeItems.forEach((item) => {
      if (
        item &&
        item.attributeName !== "Address" &&
        item.attributeName !== "State" &&
        item.attributeName !== "Country" &&
        item.attributeName !== "City" &&
        item.attributeName !== "Area" &&
        item.attributeName !== "Lat" &&
        item.attributeName !== "Lng"
      ) {
        let type = item.attributeValueType,
          name = item.attributeName;
        // check key value is allowed type
        if (typeSet.has(type)) {
          let attObj = {
            ...item,
            type,
            name,
          };
          attributesMap.set(type, attributesMap.get(type).concat([attObj]));
          if (type == "Array") {
            if (attObj.UIConcern === "Select") {
              let options = new Map(
                attObj.attributeItems.map((a) => [
                  a._id,
                  {
                    label: a.attributeName,
                    value: a._id,
                  },
                ])
              );
              valuesMap[name] = valuesMap[name].map((o) => options.get(o));
            }
            if (attObj.UIConcern === "Object") {
              valuesMap[name] = valuesMap[name];
            }
            if (attObj.UIConcern === "Checkbox") {
              valuesMap[name] = valuesMap[name];
            }
          }
          if (["Number", "String"].includes(type)) {
            const addresses = {
              Number: "integer_attributes",
              String: "string_attributes",
            };
            const attributes = result[addresses[type]];
            const valueItem = attributes.find(
              (pair) => pair.attribute_name == name
            );
            if (valueItem) {
              valuesMap[name] = valueItem.attribute_value;
            }
          }
        }
      } else if (item.attributeName === "Address") {
        this.isAddresscapture = true;
      }
    });
    this.attributesMap = attributesMap;
    this.valuesMap = valuesMap;
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.card-wrap {
  border: none !important;
  box-shadow: 0px 0px 10px 1px rgb(235, 235, 235) !important;
  border-radius: 1px !important;
}

.card-title {
  font-size: 1em;
  font-weight: 800;
  padding-left: 14px;
  padding-top: 10px;
}
</style>
